import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import MyModal from 'helpers/MyModal.js';
import React, { useEffect, useState } from 'react';
import TiposEventosTable from './_TiposEventosTable.js';
import EditTipoEvento from './_EditTipoEvento.js';
const URI = ApiEndpoint + 'configuration/';

const TiposEventos = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [openModal, setOpenModal] = useState(false);
  const [tiposEventos, setTiposEventos] = useState(false);

  const [idTipoEventoEdit, setIdTipoEventoEdit] = useState(false);

  const handleClose = () => {
    setOpenModal(false);
    getTiposEventosList();
  };

  const getTiposEventosList = async () => {
    console.log('entre a eventtypes');
    setTiposEventos(null);

    httpClient('GET', URI + 'eventtypes/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setTiposEventos(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getTiposEventosList();
  }, []);

  return (
    <>
      {tiposEventos && (
        <TiposEventosTable
          tiposeventos={tiposEventos}
          setIdTipoEvento={setIdTipoEventoEdit}
          setOpenModal={setOpenModal}
        ></TiposEventosTable>
      )}
      {/* {openConfirm && (
        <ConfirmAction
          message={'Desea eliminar el registro?'}
          title={'Confirmacion'}
          handleClose={handleCloseConfirm}
          open={openConfirm}
          ConfirmAction={DeleteConfirmed}
        ></ConfirmAction>
      )} */}
      {openModal && (
        <MyModal
          id="id_myModal"
          title={
            (idTipoEventoEdit > 0 ? 'Editar' : 'Agregar') + ' Tipos de Evento'
          }
          openModal={openModal}
          closeModal={handleClose}
        >
          <EditTipoEvento
            closeModal={handleClose}
            idTipoEvento={idTipoEventoEdit}
          ></EditTipoEvento>
        </MyModal>
      )}
    </>
  );
};
export default TiposEventos;
